import image1 from '../src/images/Full_stack_developer-1-1.jpg'
import image2 from '../src/images/android.png'
import image3 from '../src/images/Cloud-computing.jpg'
import image4 from '../src/images/bigdata.jpg'
import image5 from '../src/images/ml.jpg'
import image6 from '../src/images/Java3.jpg'

const Sdata=[{
    img:image1,
    title:"Web Development",
    text:'Learn Web Development With experts'
},
{
    img:image2,
    title:"Android Development",
    text:'Learn Android Development With experts'
},
{
    img:image3,
    title:"Cloud Computing",
    text:'Learn Cloud Computing With experts'
},
{
    img:image4,
    title:"Iot And Big Data",
    text:'Learn IOT and Big Data Development With experts'
},
{
    img:image5,
    title:"Machine Learning",
    text:'Learn Machine Learning Concepts With experts'
},
{
    img:image6,
    title:"Java Development OOPs",
    text:'Learn Java And OOPS Concepts With experts'
}
]
export default Sdata;
